// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1bORJ","ranges":"BmiRanges_ranges__3se-h"};